
import React from 'react';

export const AboutAuthorSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://m.media-amazon.com/images/S/amzn-author-media-prod/jqafei7pb9hft2quq2ckn55q1n._SY450_CR0%2C0%2C450%2C450_.jpg"
              alt="Jeffery Long - Author"
              className="w-80 h-80 rounded-full mx-auto object-cover shadow-2xl"
            />
          </div>
          
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">About the Author</h2>
            
            <div className="prose prose-lg text-gray-700 space-y-6">
              <p>
                <strong>Numbers 6:24-26</strong> "The Lord bless you and keep you; the Lord make his face shine on you and be gracious to you; the Lord turn his face toward you and give you peace."
              </p>
              
              <p>
                I have been running my own business for over 40 years, specializing in corporate governance, client acquisition, and strategic partnerships to drive scalable revenue growth. Through Business Development Authority Inc., I oversee multiple specialized divisions including Travel Authority, AI Consulting Authority, AI Book Authority, and Real Estate Development Authority.
              </p>
              
              <p>
                My expertise spans across infinite banking concepts, AI-powered investment strategies, real estate development, tax sales overages, and personal development. I'm passionate about sharing practical knowledge that helps individuals and businesses achieve financial independence and prosperity.
              </p>
              
              <p>
                Located in Chino Valley, Arizona, I continue to write, consult, and mentor others in building sustainable wealth through innovative financial strategies and emerging technologies.
              </p>
            </div>
            
            <div className="mt-8 flex flex-wrap gap-4">
              <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium">
                Financial Expert
              </span>
              <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-medium">
                Business Development
              </span>
              <span className="bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm font-medium">
                AI Consulting
              </span>
              <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full text-sm font-medium">
                Real Estate
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
